// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from '../services/vuestic-ui'
import store from '../store/index'
import router from '../router/index'
import { VuesticPlugin } from '../services/vuestic-ui/components'
import { originalTheme } from '@/services/themes-config'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'

import '../metrics'

window.$ApiHost = process.env.VUE_APP_API_HOST

if (window.location.protocol === 'http:' && window.location.hostname !== 'localhost') {
  window.location.protocol = 'https:'
}

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)

Vue.use(
  ColorThemePlugin,
  JSON.parse(localStorage.getItem('palette'))?.colors ?? originalTheme.colors,
)

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.me.isLogin) {
      return next('/auth')
    }
  }
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
